
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/resources/insurance-fraud-guide",
      function () {
        return require("private-next-pages/compliance/resources/insurance-fraud-guide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/resources/insurance-fraud-guide"])
      });
    }
  